module.exports = require("isarray");


//////////////////
// WEBPACK FOOTER
// external "isarray"
// module id = 592
// module chunks = 0